// extracted by mini-css-extract-plugin
module.exports = {"parts_box":"PartsBoxList_parts_box__telJE"};